import React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import DashboardHeaderView from './DashboardHeaderView'

export type DashboardContainerProps = {
  children: React.ReactNode
  mode: 'single' | 'multi' | 'host' | undefined
  fullScreen: boolean
  gameState: string
  musicIsPlaying: boolean
  volumeExpanded: boolean
  volumeLevel: number
  appUserId?: number
  avatarMenuAnchorEl: HTMLElement | null
  avatarMenuOpen: boolean
  onTitleClick: () => void
  onToggleMusic: () => void
  onExpandVolume: (expanded: boolean) => void
  onVolumeChange: (value: number) => void
  onAvatarMenuClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  onAvatarMenuClose: () => void
  onLogin: () => void
  onAccount: () => void
  showAdminOption?: boolean
  onAdmin?: () => void
  onLogout: () => void
}

const DashboardContainer: React.FC<DashboardContainerProps> = ({
  children,
  mode,
  fullScreen,
  gameState,
  musicIsPlaying,
  volumeExpanded,
  volumeLevel,
  appUserId,
  avatarMenuAnchorEl,
  avatarMenuOpen,
  onTitleClick,
  onToggleMusic,
  onExpandVolume,
  onVolumeChange,
  onAvatarMenuClick,
  onAvatarMenuClose,
  onLogin,
  onAccount,
  showAdminOption,
  onAdmin,
  onLogout,
}) => {
  return (
    <Container
      maxWidth="md"
      className="rt-page"
      sx={{
        pb: fullScreen ? 4 : 10,
        minHeight: mode === 'single' && fullScreen ? '100dvh' : '100vh',
        px: { xs: 1.5, sm: 3 },
      }}
    >
      <Box
        sx={{
          background: 'transparent',
          backdropFilter: 'none',
          paddingBottom:
            mode === 'single' && fullScreen ? 'calc(env(safe-area-inset-bottom, 0px) + 24px)' : 16,
          paddingX: 0,
          borderRadius: '0px',
          border: 'none',
          // minHeight: mode === 'single' && fullScreen ? '100dvh' : '100vh',
          overflow: 'visible',
          display: mode === 'single' && fullScreen && gameState === 'active' ? 'flex' : 'block',
          flexDirection:
            mode === 'single' && fullScreen && gameState === 'active' ? 'column' : undefined,
        }}
      >
        <DashboardHeaderView
          fullScreen={fullScreen}
          musicIsPlaying={musicIsPlaying}
          volumeExpanded={volumeExpanded}
          volumeLevel={volumeLevel}
          onTitleClick={onTitleClick}
          onToggleMusic={onToggleMusic}
          onExpandVolume={onExpandVolume}
          onVolumeChange={onVolumeChange}
          appUserId={appUserId}
          avatarMenuAnchorEl={avatarMenuAnchorEl}
          avatarMenuOpen={avatarMenuOpen}
          onAvatarMenuClick={onAvatarMenuClick}
          onAvatarMenuClose={onAvatarMenuClose}
          onLogin={onLogin}
          onAccount={onAccount}
          showAdminOption={showAdminOption}
          onAdmin={onAdmin}
          onLogout={onLogout}
        />
        {children}
      </Box>
    </Container>
  )
}

export default DashboardContainer
